import dayjs from "dayjs"
import { emailValido as éEmailValido } from "../../common/shareds/sharedEmail"

export const obrigatorio = (valor: unknown) => {
	if (typeof valor === 'boolean') { return true }
	if (valor === 0) { return true }
	return !!valor || 'Obrigatório'
}

export const numeroPositivo = (valor: any) => {
	if (typeof valor === 'number' && valor > 0) {
		return true
	}
	return 'Deve ser um número positivo'
}

export const urlValida = (valor: string) => {
	if (!valor) return true
	return /^https?:\/\/.+/.test(valor) || 'URL inválida'
}

export const dataValida = (valor: string) => {
	if (!valor) return true
	const day = dayjs(valor, 'DD/MM/YYYY', true)
	return day.isValid() || 'Deve ser uma data válida'
}

export const emailValido = (valor?: string | null) => {
	if (!valor) return true
	return éEmailValido(valor) || 'E-mail inválido'
}

export const senhaMinima = (valor?: string | null) => {
	if (!valor) return true
	return valor.length >= 6 || 'A senha deve ter pelo menos 6 caracteres'
}
